import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import type { GetAllInvestigationAssigneeCandidatesResult } from './get-all-investigation-assignee-candidates.result';

@Injectable({ providedIn: 'root' })
export class GetAllInvestigationAssigneeCandidatesUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(investigationIds: string[]): Observable<GetAllInvestigationAssigneeCandidatesResult> {
    return this._repository
      .getBulkInvestigationAssignmentOptions(investigationIds)
      .pipe(map((candidates) => ({ candidates })));
  }
}
